export function formatPlayerRatingScore(score?: number | null): string {
	if (score == null || Number.isFinite(Number(score)) === false) {
		return "-";
	}

	return Number(score).toFixed(1);
}

export function roundPlayerRatingScore(score: number): number {
	return Number(score.toFixed(1));
}
